import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "col-12"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "btn-toolbar mb-2 mb-md-0" }
const _hoisted_9 = { style: {"width":"100%","list-style":"none","text-align":"left","font-size":"20px"} }
const _hoisted_10 = { style: {"border-bottom":"1px lightgray solid"} }
const _hoisted_11 = { style: {"list-style":"none","background":"whitesmoke"} }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_17 = { class: "col-6 offset-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", null, " メニューの追加 ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "col-6 offset-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h3", null, " メニュー設定 ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("input", {
  type: "file",
  class: "form-control",
  id: "file-menu"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = { class: "col-6 offset-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h3", null, "CSSの編集", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { class: "col-6 offset-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", null, "WebDav", -1)
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { style: {"font-weight":"bold","text-align":"left"} }
const _hoisted_40 = { style: {"display":"inline-block","width":"100%"} }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = { style: {"display":"inline-block","width":"100%"} }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = { class: "col-6 offset-3" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h3", null, " Sqlite", -1)
const _hoisted_48 = { class: "col-6 offset-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h3", null, " ChatGPT設定 ", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("b", null, "OpenAI APIKey", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("b", null, "利用するモデル", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_59 = ["value"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("b", null, "事前に会話を読み込む", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("pre", { style: {"text-align":"left"} }, " * ChatGPTに演じてほしい役割や、望ましい会話を事前に読み込ませることができます。\nsystem 設定 ,  user 利用者 , assistant ChatGPTの応答 \n例\nsystem:あなたはPaletteIoTダッシュボードのアシスタントです。\nsystem:センサデータの取得要望に対してsqlite3で利用できるSQLを応答してください。以下はテーブル定義です。\nsystem:table ( ....")
], -1)
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("option", null, "system", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("option", null, "user", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("option", null, "assistant", -1)
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Push = _resolveComponent("Push")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", {
      class: "h2",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showRouterBtn && _ctx.showRouterBtn(...args)))
    }, "アプリ設定"),
    _hoisted_1,
    _withDirectives(_createElementVNode("span", null, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.path) = $event)),
        type: "text"
      }, null, 512), [
        [_vModelText, _ctx.path]
      ]),
      _createTextVNode(),
      _createElementVNode("button", {
        class: "btn btn-dark",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pathTo && _ctx.pathTo(...args)))
      }, "設定")
    ], 512), [
      [_vShow, _ctx.showSecretMode]
    ]),
    (_ctx.isLoggedin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", null, " 現在のバージョン: " + _toDisplayString(_ctx.currentVersion), 1),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _hoisted_4,
    (_ctx.isOnline() && _ctx.isNewVersionAvailable())
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-dark",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
          }, " アプリの更新 "),
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Push, {
      isShow: _ctx.isShowPush,
      onShowFlash: _ctx.showFlash
    }, null, 8, ["isShow", "onShowFlash"]),
    _hoisted_7,
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      _createElementVNode("ul", _hoisted_9, [
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("span", {
            style: {"cursor":"pointer"},
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowLicense=!_ctx.isShowLicense))
          }, "ライセンス ")
        ])
      ]),
      _withDirectives(_createElementVNode("ul", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.licenses, (license, i) => {
          return (_openBlock(), _createElementBlock("li", { key: i }, [
            (String(license.license) !=='' & String(license.module_name) !== '' & String(license.license).indexOf('Custom:_') !== 0 )
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("b", null, _toDisplayString(license.module_name), 1),
                  _hoisted_13,
                  (license.publisher)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, " Publisher: " + _toDisplayString(license.publisher), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, "License: " + _toDisplayString(license.license), 1),
                  _hoisted_15,
                  _createElementVNode("span", null, "Repository:" + _toDisplayString(license.repository), 1),
                  _hoisted_16
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.isShowLicense]
      ])
    ], 512), [
      [_vShow, _ctx.isPWA]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _hoisted_19,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newMenuTitle) = $event))
      }, null, 512), [
        [_vModelText, _ctx.newMenuTitle]
      ]),
      _createTextVNode(),
      _hoisted_20,
      _createElementVNode("button", {
        class: "btn btn-dark",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addMenu && _ctx.addMenu(...args)))
      }, " 追加 ")
    ], 512), [
      [_vShow, _ctx.showSecretMode]
    ]),
    _hoisted_21,
    _withDirectives(_createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _hoisted_24,
      _createElementVNode("button", {
        class: "btn btn-dark",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.exportMenu && _ctx.exportMenu(...args)))
      }, " エクスポート "),
      _hoisted_25,
      _hoisted_26,
      _hoisted_27,
      _createTextVNode(),
      _hoisted_28,
      _createElementVNode("button", {
        class: "btn btn-dark",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.importMenu && _ctx.importMenu(...args)))
      }, " インポート "),
      _hoisted_29
    ], 512), [
      [_vShow, _ctx.showSecretMode]
    ]),
    _hoisted_30,
    _withDirectives(_createElementVNode("div", _hoisted_31, [
      _hoisted_32,
      _hoisted_33,
      _createElementVNode("button", {
        class: "btn btn-dark",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.editCustomCSS && _ctx.editCustomCSS(...args)))
      }, " 編集する ")
    ], 512), [
      [_vShow, _ctx.showSecretMode]
    ]),
    _hoisted_34,
    _withDirectives(_createElementVNode("div", _hoisted_35, [
      _hoisted_36,
      _hoisted_37,
      (_ctx.fileserveruser.username !='' && _ctx.fileserveruser.password!='' )
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("span", _hoisted_40, " User : " + _toDisplayString(_ctx.fileserveruser.username), 1),
              _createTextVNode(),
              _hoisted_41,
              _createElementVNode("span", _hoisted_42, " Password : " + _toDisplayString(_ctx.fileserveruser.password), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_43,
      _hoisted_44
    ], 512), [
      [_vShow, _ctx.showSecretMode]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_45, [
      _hoisted_46,
      _hoisted_47,
      _createElementVNode("button", {
        class: "btn btn-dark",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.dumpDB && _ctx.dumpDB(...args)))
      }, "エクスポート ")
    ], 512), [
      [_vShow, _ctx.showSecretMode]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_48, [
      _hoisted_49,
      _hoisted_50,
      _hoisted_51,
      _hoisted_52,
      _createTextVNode(),
      _hoisted_53,
      _withDirectives(_createElementVNode("input", {
        type: "password",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.openaiApiKey) = $event)),
        placeholder: "OpenAI APIKEY",
        class: "form-control",
        id: "file-menu"
      }, null, 512), [
        [_vModelText, _ctx.openaiApiKey]
      ]),
      _createTextVNode(),
      _hoisted_54,
      _createElementVNode("button", {
        class: "btn btn-dark",
        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.saveOpenAIAPIKey && _ctx.saveOpenAIAPIKey(...args)))
      }, "設定する "),
      _hoisted_55,
      _hoisted_56,
      _hoisted_57,
      _hoisted_58,
      _withDirectives(_createElementVNode("select", {
        class: "form-control",
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedOpenaiModel) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openaiModels, (model) => {
          return (_openBlock(), _createElementBlock("option", {
            value: model,
            key: model
          }, _toDisplayString(model), 9, _hoisted_59))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.selectedOpenaiModel]
      ]),
      _hoisted_60,
      _hoisted_61,
      _hoisted_62,
      _createTextVNode(),
      _hoisted_63,
      _hoisted_64,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatgptPrescripts, (prescript, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: prescript }, [
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": ($event: any) => ((prescript.role) = $event)
          }, [
            _hoisted_66,
            _createTextVNode(),
            _hoisted_67,
            _createTextVNode(),
            _hoisted_68
          ], 8, _hoisted_65), [
            [_vModelSelect, prescript.role]
          ]),
          _withDirectives(_createElementVNode("textarea", {
            row: "1",
            class: "form-control",
            "onUpdate:modelValue": ($event: any) => ((prescript.content) = $event)
          }, null, 8, _hoisted_69), [
            [_vModelText, prescript.content]
          ]),
          _createElementVNode("b", {
            style: {"cursor":"pointer","margin":"8px","font-size":"18px"},
            onClick: ($event: any) => (_ctx.addChatgptPrescript(i))
          }, " + ", 8, _hoisted_70),
          _createElementVNode("b", {
            style: {"cursor":"pointer","margin":"8px","font-size":"18px"},
            onClick: ($event: any) => (_ctx.reduceChatgptPrescript(i))
          }, " - ", 8, _hoisted_71),
          _hoisted_72
        ], 64))
      }), 128)),
      _createElementVNode("button", {
        class: "btn btn-dark",
        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.saveOpenAIConf && _ctx.saveOpenAIConf(...args)))
      }, "設定する"),
      _hoisted_73,
      _hoisted_74
    ], 512), [
      [_vShow, _ctx.showSecretMode]
    ]),
    _hoisted_75,
    _hoisted_76
  ]))
}